import {
    DATA_DETAILS_OPEN_MODAL,
    DATA_DETAILS_CLOSE_MODAL,
} from 'Redux/actionTypes';

export const dataDetailsOpenModal = (item) => ({
    type: DATA_DETAILS_OPEN_MODAL,
    payload: item
})

export const dataDetailsCloseModal = () => ({
    type: DATA_DETAILS_CLOSE_MODAL
})